import React from 'react';
import LogoWritten from "./assets/images/wv_logo_written.png"
import LogoDark from "./assets/images/wv_logo_dark.png"

const ErrorPage = () => {
    return (
        <div className='error-page'>
            <img src={LogoDark} alt=""/>
            <h1>There was an error</h1>
            <h4>It seems like you have the wrong link</h4>
            <p>If you feel like you should not be seeing this, please, contact us via our <a href='https://www.kitlegit.com/contact/'>website</a></p>
            <hr/>
            <img src={LogoWritten} alt=""/>
        </div>
    )
}

export default ErrorPage